import currentEnv from "@env";
import type { Environment, EnvironmentName } from "./types";

export const environments: EnvironmentName[] = ["local", "prod", "test"];

export const getCurrentEnv = (): Environment => currentEnv;
